import React from 'react';
import PbssFilesContainer from '../../../Containers/AdminContainer/PbssFiles';

const PbssFilesScreen = () => {
  return <PbssFilesContainer />;
};

export default PbssFilesScreen;
